import { render, staticRenderFns } from "./ConsultantPhysicalFranchiseHistory.vue?vue&type=template&id=1662fa88"
import script from "./ConsultantPhysicalFranchiseHistory.vue?vue&type=script&lang=js"
export * from "./ConsultantPhysicalFranchiseHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports